type LineInterval = {
  start: number;
  end: number;
};

const groupLines = (lineNumbers: number[]) => {
  const groupedLines = lineNumbers
    .filter(lineNumber => lineNumber > 0)
    .reduce((result: LineInterval[], currentLine: number) => {
      const lastInterval = result[result.length - 1];
      if (lastInterval && currentLine === lastInterval.end + 1) {
        lastInterval.end = currentLine;
      } else {
        result.push({ start: currentLine, end: currentLine });
      }
      return result;
    }, []);

  return groupedLines
    .map(interval =>
      interval.start === interval.end
        ? interval.start
        : `${interval.start}:${interval.end}`
    )
    .join(',');
};

export default (
  filename: string,
  lineNumbers: number[]
): string | null | undefined => {
  const lines = groupLines(lineNumbers);
  return lines ? `${filename}-${groupLines(lineNumbers)}` : null;
};
